module.exports = __webpack_public_path__ + "static/media/social-media-cloud-svgrepo-com.99eb208d.svg";